// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Created by Inzamam Janjua on 18/05/2023.
 */
.auth-wrapper {
  width: 100%;
  height: 100vh;
  padding: 26px 20px 17px 20px;
}

.gc-auth-leftPanel {
  height: 100%;
  background: url('login-banner.49de8a8e4c6bbf48.png') no-repeat center center;
  background-size: cover;
  border-radius: 16px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}

.gc-idnty-container {
  padding: 0 80px;
  margin-top: -100px;
}
.gc-idnty-container .portal-subtitle {
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  line-height: 20px;
  letter-spacing: 2.5px;
  text-transform: uppercase;
  color: rgba(255, 255, 255, 0.65);
  margin-top: 20px;
  margin-bottom: 0;
}
.gc-idnty-container .portal-headline {
  margin-top: 48px;
}
.gc-idnty-container .portal-headline p {
  font-size: 42px;
  font-weight: 500;
  color: #ffffff;
  line-height: 1.2;
  margin: 0;
  letter-spacing: -0.5px;
}
.gc-idnty-container .portal-headline .portal-highlight {
  color: #6ACE6A;
  font-style: italic;
}

.password-check {
  height: 4px;
  width: 100px;
  background-color: #ccc;
}

.password-strength-container {
  display: flex;
  justify-content: flex-end;
}

.weak-password {
  background-color: #FF6B6B; /* Red color */
}

.medium-password {
  background-color: #FEBD2E; /* Yellow color */
}

.strong-password {
  background-color: #66DE93; /* Green color */
}

/* Weak Password Text Style */
.weak-password-text {
  color: #FF6B6B; /* Red color */
  margin: -15px 0 0 0;
}

/* Medium Password Text Style */
.medium-password-text {
  color: #FEBD2E;
  margin: -12px; /* Yellow color */
}

/* Strong Password Text Style */
.strong-password-text {
  color: #66DE93; /* Green color */
  margin: -15px 0 0 0;
}

.gc-auth-slider {
  padding: 0 56px;
  margin-top: 60px;
}

.password-req {
  font-size: 12px;
  margin-top: 8px;
  display: inline-block;
  line-height: 28px;
}
@media (max-width: 1640px) {
  .password-req {
    line-height: 16px;
  }
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
